import { Box } from '@chakra-ui/react';
import React from 'react';

interface NotificationProps {}

const Notification: React.FC<NotificationProps> = ({ children }) => {
  if (!children || React.Children.count(children) === 0) {
    return null;
  }

  return (
    <Box
      className="WLHeader-Notification"
      flexBasis="auto"
      flexGrow="1"
      flexShrink="1"
      alignItems="start"
      paddingLeft={{ lg: '16px' }}
      width="full"
      height="100%"
      color="white"
      sx={{
        a: {
          color: 'white',
          paddingX: '16px',
          height: '100%',
          _hover: {
            color: 'white',
            textDecoration: 'underline',
          },
          // TODO: Must be a better way to handle these multiple font-size "overrides". -NE 20220329
          p: {
            margin: 0,
            fontSize: '13px',
            lineHeight: '18px',
            b: {
              margin: 0,
              fontSize: '13px',
              lineHeight: '18px',
            },
          },
        },
        p: {
          margin: 0,
          fontSize: '13px',
          lineHeight: '18px',
        },
      }}
    >
      {children}
    </Box>
  );
};

export default Notification;
